var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');
var load_more_btn = $('.load-more');

function loadMoreProducts() {
    // Button animation
    var buttonText = load_more_btn.find('.button-text');
    var preloader = load_more_btn.find('.load-more__preloader');
    buttonText.css('opacity', '0');
    preloader.css('opacity', '1');
    setTimeout(function() {
        preloader.css('opacity', '0');
        buttonText.css('opacity', '1');
    }, 1000);
  
    $.ajax (
        {
            url: next_url,
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(next_page) {
        var new_products = $(next_page).find('.products-on-page');
        var new_url = new_products.data('next-url');

        next_url = new_url;
      
        var productGrid = document.getElementById("collection-grid");
        productGrid.setAttribute("data-next-url", next_url);
      
        products_on_page.append(new_products.html());

        if(next_url === undefined || next_url == '') {
            load_more_btn.hide()
        }
    })
}